const ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  IN_APP_TODAY: "/in-app/today",
  IN_APP_TODAY_NUTRITION: "/in-app/today/nutrition",
  IN_APP_TODAY_NUTRITION_QUICK_LINK_DETAILS:
    "/in-app/today/nutrition/quick-link/:quickLinkId",
  IN_APP_TODAY_QUICK_LINKS: "/in-app/today/quick-links",
  IN_APP_TODAY_QUICK_LINKS_LINK_DETAILS:
    "/in-app/today/quick-links/quick-link/:quickLinkId",
  IN_APP_TODAY_BANNERS: "/in-app/today/day-banners",
  IN_APP_NUTRITION: "/in-app/nutrition/categories",
  IN_APP_NUTRITION_CATEGORY_DETAILS: "/in-app/nutrition/categories/:id",
  IN_APP_NUTRITION_CATEGORY_DETAILS_RECIPE_DETAILS:
    "/in-app/nutrition/categories/:id/recipe/:recipeId",
  IN_APP_STUDIO: "/in-app/studio/categories",
  IN_APP_STUDIO_CATEGORY_DETAILS: "/in-app/studio/categories/:id",
  IN_APP_STUDIO_WORKOUT_SEQUENCE_DETAILS:
    "/in-app/studio/workout-sequences/:id",
  IN_APP_STUDIO_CATEGORY_DETAILS_WORKOUT_DETAILS:
    "/in-app/studio/categories/:id/workout/:workoutId",
  IN_APP_RESOURCES: "/in-app/resources/categories",
  IN_APP_RESOURCES_CATEGORY_DETAILS: "/in-app/resources/categories/:id",
  IN_APP_RESOURCES_CATEGORY_DETAILS_QUICK_LINK_DETAILS:
    "/in-app/resources/categories/:id/quick-link/:quickLinkId",
  IN_APP_WORKOUT_SEQUENCES: "/in-app/workout-sequences",
  IN_APP_MANUAL_BADGES: "/in-app/manual-badges",
  IN_APP_MANUAL_BADGES_DETAILS:
    "/in-app/manual-badges/manual-badge/:manualBadgeId?",

  CONTENT_CONTENT_COLLECTIONS: "/content/content-collections",
  CONTENT_ADD_EDIT_COLLECTION: "/content/add-edit-collection/:id?",
  CONTENT_NUTRITION: "/content/nutrition",
  CONTENT_NUTRITION_RECIPES: "/content/nutrition/recipes",
  CONTENT_NUTRITION_RECIPE_DETAILS: "/content/nutrition/recipe/:recipeId?",
  CONTENT_STUDIO: "/content/studio",
  CONTENT_STUDIO_WORKOUTS: "/content/studio/workouts",
  CONTENT_STUDIO_WORKOUT_DETAILS: "/content/studio/workout/:workoutId?",
  CONTENT_STUDIO_MOVEMENTS: "/content/studio/movements",
  CONTENT_STUDIO_EQUIPMENT: "/content/studio/equipment",
  CONTENT_RESOURCES: "/content/resources",
  CONTENT_RESOURCES_QUICK_LINKS: "/content/resources/quick-links",
  CONTENT_RESOURCES_QUICK_LINK_DETAILS:
    "/content/resources/quick-link/:quickLinkId?",
  CONTENT_TAGS: "/content/tags",

  CONTENT_QUESTIONNAIRE: "/content/questionnaire",
  CONTENT_QUESTIONNAIRE_QUIZ: "/content/questionnaire/quizzes",
  CONTENT_QUESTIONNAIRE_QUIZ_DETAILS: "/content/questionnaire/quiz/:quizId?",
  CONTENT_QUESTIONNAIRE_SECTION: "/content/questionnaire/sections",
  CONTENT_QUESTIONNAIRE_SECTION_DETAILS:
    "/content/questionnaire/section/:sectionId?",
  CONTENT_QUESTIONNAIRE_QUESTION: "/content/questionnaire/questions",
  CONTENT_QUESTIONNAIRE_QUESTION_DETAILS:
    "/content/questionnaire/question/:questionId?",

  CONTENT_PERSONAL: "/content/personal",
  CONTENT_PERSONAL_COACH: "/content/personal/coaches",
  CONTENT_PERSONAL_COACH_DETAIL: "/content/personal/coach/:coachId?",
  CONTENT_PROFILE: "/content/profile",
  CONTENT_PROFILE_USER: "/content/profile/users",
  CONTENT_PROFILE_USER_DETAIL: "/content/profile/user/:userId?",
  CONTENT_PROFILE_USER_DATA_DETAIL: "/content/profile/user/:userId?/data",

  CONTENT_TRIVIA: "/content/trivias",
  CONTENT_TRIVIA_DETAIL: "/content/trivias/trivia/:triviaId?",

  CONTENT_TRIVIA_QUESTION: "/content/trivia/trivia/questions",
  CONTENT_TRIVIA_QUESTION_DETAIL:
    "/content/trivia/trivia/question/:questionId?",

  CONTENT_TIPS: "/content/tips",
  CONTENT_TIPS_LINK_DETAILS: "/content/tip/:tipId?",

  CONTENT_PATTERNS: "/content/patterns",
  CONTENT_PATTERNS_PATTERNS: "/content/patterns/patterns",
  CONTENT_PATTERNS_PATTERNS_LINK_DETAILS:
    "/content/patterns/pattern/:patternId?",

  CONTENT_CLAIMS: "/content/claims",
  CONTENT_CLAIMS_DETAILS: "/content/claims/claim/:id?",
  CONTENT_RESTRICTION: "/content/restrictions",
  CONTENT_RESTRICTION_DETAILS: "/content/restrictions/restriction/:id?",
  CONTENT_HEALTH_CONDITION: "/content/health-conditions",
  CONTENT_HEALTH_CONDITION_DETAILS:
    "/content/health-conditions/health-condition/:id?",

  CONTENT_ACTIVE_PROGRAM: "/content/active-programs",
  CONTENT_ACTIVE_PROGRAM_DETAILS: "/content/active-program/:id?",

  CONTENT_GREETINGS: "/content/greetings",

  CONTENT_TARGET_ZONES: "/content/target-zones",
  CONTENT_TARGET_ZONES_DETAILS: "/content/target-zone/:id?",

  CONTENT_TRAINERS: "/content/trainers",
  CONTENT_TRAINERS_DETAILS: "/content/trainer/:id?",

  SETTINGS_USERS: "/settings/users",
};

export default ROUTES;
